// extracted by mini-css-extract-plugin
module.exports = {"term":"styles-module--term--bU8nu"};